/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LegalTechSkillCategory {
  LegalResearch = "LegalResearch",
  ContractDrafting = "ContractDrafting",
  ContractReviewing = "ContractReviewing",
  ContractLifecycleManagementCLM = "ContractLifecycleManagementCLM",
  DocumentManagement = "DocumentManagement",
  MatterAndTransactionManagement = "MatterAndTransactionManagement",
  DisputeManagementAndeDiscovery = "DisputeManagementAndeDiscovery",
  OtherTools = "OtherTools",
}

export const LegalTechSkillCategoryDisplay: Record<LegalTechSkillCategory, string> = {
  [LegalTechSkillCategory.LegalResearch]: "Legal Research",
  [LegalTechSkillCategory.ContractDrafting]: "Contract Drafting",
  [LegalTechSkillCategory.ContractReviewing]: "Contract Reviewing",
  [LegalTechSkillCategory.ContractLifecycleManagementCLM]: "Contract Lifecycle Management (CLM)",
  [LegalTechSkillCategory.DocumentManagement]: "Document Management",
  [LegalTechSkillCategory.MatterAndTransactionManagement]: "Matter & Transaction Management",
  [LegalTechSkillCategory.DisputeManagementAndeDiscovery]: "Dispute Management & eDiscovery",
  [LegalTechSkillCategory.OtherTools]: "Other Tools",
};
